import { render, staticRenderFns } from "./ConfirmationApproval.vue?vue&type=template&id=708b0cfd&scoped=true"
import script from "./ConfirmationApproval.vue?vue&type=script&lang=js"
export * from "./ConfirmationApproval.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationApproval.vue?vue&type=style&index=0&id=708b0cfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b0cfd",
  null
  
)

export default component.exports